import { ArrowUpRight } from "lucide-react";
import { track } from "@/lib/analytics";
import { SOCIALS, SKOOL_URL, CONTACT_EMAIL } from "@/lib/data";

export const Footer = () => {
  return (
    <footer className="relative bg-[#050505] border-t border-white/10" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 lg:py-20">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-start">
          <div className="lg:col-span-6">
            <div className="flex items-center gap-2 mb-5">
              <span className="font-heading text-xl tracking-[0.25em] uppercase text-white">TAPSS</span>
            </div>
            <p className="text-white/50 leading-relaxed text-[15px] max-w-md">
              Producer &amp; creative partner. Turning production, plaques, publishing and community into one home base — connecting the ecosystem.
            </p>
            <a
              href="#book-call"
              onClick={() => track("booking_click", "footer")}
              data-testid="footer-book-cta"
              className="group mt-8 inline-flex items-center gap-2 px-7 py-3.5 rounded-full bg-gold text-black text-[13px] tracking-[0.12em] uppercase font-medium hover:-translate-y-1 transition-transform duration-300"
            >
              Book a Call <ArrowUpRight size={16} className="group-hover:rotate-45 transition-transform duration-300" />
            </a>
          </div>

          <div className="lg:col-span-6 grid grid-cols-2 gap-8">
            <div>
              <p className="text-[11px] tracking-[0.2em] uppercase text-white/35 mb-4">Explore</p>
              <ul className="space-y-2.5">
                {[["Work", "#work"], ["Partnership", "#partnership"], ["Sessions", "#sessions"], ["Contact", "#contact"]].map(([l, h]) => (
                  <li key={h}><a href={h} className="text-white/60 hover:text-gold transition-colors text-[14px]">{l}</a></li>
                ))}
              </ul>
            </div>
            <div>
              <p className="text-[11px] tracking-[0.2em] uppercase text-white/35 mb-4">Connect</p>
              <ul className="space-y-2.5">
                {SOCIALS.map((s) => (
                  <li key={s.label}>
                    <a href={s.href} target="_blank" rel="noopener noreferrer" className="text-white/60 hover:text-gold transition-colors text-[14px]">{s.label}</a>
                  </li>
                ))}
                <li><a href={SKOOL_URL} target="_blank" rel="noopener noreferrer" onClick={() => track("skool_click", "footer")} className="text-white/60 hover:text-gold transition-colors text-[14px]">Skool</a></li>
                <li><a href={`mailto:${CONTACT_EMAIL}`} className="text-white/60 hover:text-gold transition-colors text-[14px]">Email</a></li>
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-white/35 text-[12px] tracking-[0.1em]">© {new Date().getFullYear()} TAPSS · tapssmusic.com</p>
          <p className="text-white/25 text-[12px] tracking-[0.1em]">Producer · Creative Partner · Entrepreneur</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
